import { CONFIG } from 'shared/config';

export const getThumbnailUrl = (url: string) => {
  return `${CONFIG.S3_URL}/${url.split('/')[3]?.split('?')[0]}.0000001.jpg`;
};
